// Central helpers for backend-served assets.
// The backend stores relative URLs like "/api/uploads/xxx" or "/api/uploads/recipe-xxx".
// We must combine them with REACT_APP_BACKEND_URL (NOT the /api-suffixed API constant),
// otherwise we get a duplicated "/api/api/..." path.

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const absoluteUrl = (u) => {
  if (!u) return null;
  if (u.startsWith("http://") || u.startsWith("https://") || u.startsWith("data:")) return u;
  if (u.startsWith("/")) return `${BACKEND_URL}${u}`;
  return u;
};

// Cheap 1×1 transparent pixel used as fallback while an image loads.
export const TRANSPARENT_PX =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='3'/>";
